<template>
  <v-container v-if="currentImport && currentErrorRow">
    <v-row>
      <v-col stretch>
        <v-breadcrumb :items="breadcrumbImportItems" :mobile="breadcrumbMobileItem"></v-breadcrumb>
      </v-col>
    </v-row>
    <v-row>
      <v-col stretch>
        <v-title-bar
          :title="
            $t('imports.row_number_number', {
              number: currentErrorRow.row_number,
            })
          "
        >
        </v-title-bar>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12">
        <ul class="list">
          <v-list-item v-for="(errorM, field) in currentErrorRow.error_messages" :key="field" simple>
            <v-list-cell :title="field" />
            <v-list-cell :value="getErrorValue(field)" size="2" />
            <v-list-cell :value="getErrors(errorM)" size="2" />
          </v-list-item>
        </ul>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ImportErrorRow",
  data() {
    return {
      breadcrumbImportItems: [
        {
          label: this.$t("menus.settings"),
          route: { name: "Settings", params: { tab: "account" } },
        },
        {
          label: this.$t("menus.imports"),
          route: { name: "Settings", params: { tab: "imports" } },
        },
      ],
      breadcrumbMobileItem: {
        label: this.$t("menus.imports"),
        route: { name: "Settings", params: { tab: "imports" } },
      },
      isLoading: false,
      title: "",
      allowedFileTypes: [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ],
      excel: null,
      file: null,
      currentExcel: null,
      customFileErrors: [],
    };
  },
  created() {
    this.loadPageData(this.$route.params.uid, this.$route.params.err);
  },
  methods: {
    ...mapActions(["getImport", "getImportError"]),
    loadPageData(uid, err) {
      const vm = this;
      vm.$store.commit("GLOBAL_CUSTOM_LOADING_STARTED");
      const p1 = vm.getImport({ params: { import: uid } });
      const p2 = vm.getImportError({ params: { import: uid, error: err } });
      Promise.all([p1, p2])
        .then(() => {
          vm.breadcrumbImportItems.push({
            label: vm.currentImport.title,
            route: { name: "Import", params: { uid: uid } },
          });
          vm.breadcrumbImportItems.push({
            label: this.$t("imports.row_number_number", {
              number: vm.currentErrorRow.row_number,
            }),
            active: true,
          });
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            this.$snotify.error(this.$t("toasts.resourceNotFound.import"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        });
    },
    getRowTitle() {
      return "";
    },
    getErrorValue(field) {
      return Object.prototype.hasOwnProperty.call(this.currentErrorRow.values, field)
        ? this.currentErrorRow.values[field]
        : "-";
    },
    getErrors(errors) {
      let err = "";
      if (errors) {
        for (const e in errors) {
          if (err) {
            err = err + ", " + errors[e];
          } else {
            err = errors[e];
          }
        }
      }
      return err;
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      currentImport: "import_get_current_import",
      currentErrorRow: "import_get_current_import_error_row",
      rows: "import_get_current_import_rows",
      teamLanguages: "teams_get_languages",
      teamsSettings: "global_get_teams_settings",
    }),
  },
};
</script>
